<div class="align-with-nav">
    <h1 class="title-heading align-with-nav">{{ this.title }}</h1>
    <ul class="light-nav">
        <li><a [routerLink]='"../../"'>Math</a></li>
        <li><a [routerLink]='"../"'>{{ this.subjectTitle}}</a></li>
    </ul>
    <app-article [articleModel]='this.article'></app-article>
</div>